import { connect } from 'react-redux';

import {
  getDashboardEventName,
  getDashboardEventSplitColumn,
  getMetainf,
} from '../../../../../reducers/analyticsApp';
import { prepareDropdown } from '../../../../../utils/common';
import EventsFieldOption from '../../../../../components/event/FieldOption';
import { splitByExcludeFields } from '../../../../../constants/metainf';
import { setSplitColumn } from '../../../../../actions/dashboards/events';

const mapStateToProps = (state, { unitId, id }) => ({
  label: 'Split by:',
  value: getDashboardEventSplitColumn(state, unitId, id),
  values: prepareDropdown(
    getMetainf(state, getDashboardEventName(state, unitId, id)),
    false,
    splitByExcludeFields
  ),
  visible: true,
});

const mapDispatchToProps = (dispatch, { unitId, id }) => ({
  onChange: (value) =>
    value === undefined
      ? dispatch(setSplitColumn(unitId, id, null))
      : dispatch(setSplitColumn(unitId, id, value)),
});

const EventsSplitByFieldOption = connect(mapStateToProps, mapDispatchToProps)(EventsFieldOption);

export default EventsSplitByFieldOption;
